import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonPrimitive } from '#pplx/frontend/aether/primitives/ButtonPrimitive/index.js';
import { IncognitoIcon } from '#pplx/frontend/apps/ask/incognito/IncognitoIcon.js';
import { useIsIncognito } from '#pplx/frontend/apps/ask/incognito/useIsIncognito.js';
import { SidebarBottomPopover } from '#pplx/frontend/apps/ask/layout-aux/sidebar-bottom/SideBarBottomPopover.js';
import { SideBarBottomSignInButton } from '#pplx/frontend/apps/ask/layout-aux/sidebar-bottom/SideBarBottomSignInButton.js';
import { useShouldShowSidebarBottomSignInButton } from '#pplx/frontend/apps/ask/layout-aux/sidebar-bottom/SideBarBottomSignInButtonShared.js';
import { SidebarBottomItem } from '#pplx/frontend/apps/ask/layout/sidebar/core/shared/SidebarBottomItem.js';
import { useIsSubscribed } from '#pplx/frontend/auth/useIsSubscribed.js';
import { useIsUserLoggedIn } from '#pplx/frontend/auth/userHooks.js';
import { useSession } from '#pplx/frontend/auth/useSession.js';
import Avatar from '#pplx/frontend/components/user/Avatar.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import classNames from 'classnames';
import { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
const planLabelMessages = defineMessages({
    free: {
        defaultMessage: 'Free plan',
        description: 'Plan label shown in the sidebar account menu for users without a paid plan',
        id: '65cf665086',
    },
    pro: {
        defaultMessage: 'Pro',
        description: 'Plan label shown in the sidebar account menu for Pro subscribers',
        id: '21663d91c6',
    },
    max: {
        defaultMessage: 'Max',
        description: 'Plan label shown in the sidebar account menu for Max subscribers',
        id: '3baf9aa0e1',
    },
    enterprisePro: {
        defaultMessage: 'Enterprise Pro',
        description: 'Plan label shown in the sidebar account menu for Enterprise Pro subscribers',
        id: 'b208f048ae',
    },
    enterpriseMax: {
        defaultMessage: 'Enterprise Max',
        description: 'Plan label shown in the sidebar account menu for Enterprise Max subscribers',
        id: 'aa204aad1f',
    },
    enterpriseViewer: {
        defaultMessage: 'Enterprise Viewer',
        id: '487a41c6c4',
        description: 'Plan label shown in the sidebar account menu for Enterprise Viewer subscribers',
    },
});
export const SidebarAccountMenu = (props) => {
    const isLoggedIn = useIsUserLoggedIn();
    if (!isLoggedIn) {
        return _jsx(LoggedOutSidebarAccountMenu, { isExpanded: props.isExpanded });
    }
    return _jsx(LoggedInSidebarAccountMenu, { ...props });
};
const LoggedOutSidebarAccountMenu = ({ isExpanded, }) => {
    const shouldShowSignInButton = useShouldShowSidebarBottomSignInButton();
    return shouldShowSignInButton ? _jsx(SideBarBottomSignInButton, { expanded: isExpanded }) : null;
};
const LoggedInSidebarAccountMenu = ({ isExpanded, alignOffset, }) => {
    const { $t } = useIntl();
    const { session } = useSession();
    const { isPro, isMax, isViewer, isEnterprisePro, isEnterpriseMax } = useIsSubscribed();
    const { isIncognito, incognitoType } = useIsIncognito({ reason: 'sidebar-account-menu' });
    const [isAccountMenuOpen, setIsAccountMenuOpen] = useState(false);
    const planLabel = $t(getPlanLabelMessage({ isPro, isMax, isViewer, isEnterprisePro, isEnterpriseMax }));
    const accountLabel = session?.user?.name ?? session?.user?.username ?? session?.user?.email;
    const showSubtitle = isExpanded;
    const tooltipSubtitle = accountLabel ? `${accountLabel} · ${planLabel}` : accountLabel;
    return (_jsx(SidebarBottomItem.Root, { isExpanded: isExpanded, forceSelectionState: isAccountMenuOpen, children: _jsx(SidebarBottomPopover, { isExpanded: isExpanded, isOpen: isAccountMenuOpen, onOpenChange: setIsAccountMenuOpen, alignOffset: alignOffset, children: _jsx("div", { className: classNames('relative flex min-w-0 flex-1', {
                    'h-full': showSubtitle,
                }), children: _jsx(ButtonPrimitive, { className: classNames('min-w-0 flex-1 rounded-lg', {
                        'w-full': !isExpanded,
                        'h-full': showSubtitle,
                    }), interactableVariant: "alt", children: _jsx(SidebarBottomItem.Leading, { label: accountLabel, subtitle: planLabel, tooltip: $t({
                            defaultMessage: 'Account & Settings',
                            description: 'Tooltip shown when hovering over the account menu button in the sidebar',
                            id: '2105dd6e49',
                        }), tooltipSubtitle: tooltipSubtitle, trailingIcon: $icon('selector'), trailingIconOnlyOnHover: true, forceSelectionState: isAccountMenuOpen, children: isIncognito ? (_jsx(IncognitoIcon, { size: "small", incognitoType: incognitoType })) : (_jsx(Avatar, { size: "base", showProBadge: false, showMaxBadge: false, user: session?.user?.image })) }) }) }) }) }));
};
function getPlanLabelMessage({ isPro, isMax, isViewer, isEnterprisePro, isEnterpriseMax, }) {
    if (isEnterpriseMax) {
        return planLabelMessages.enterpriseMax;
    }
    if (isEnterprisePro) {
        return planLabelMessages.enterprisePro;
    }
    if (isViewer) {
        return planLabelMessages.enterpriseViewer;
    }
    if (isMax) {
        return planLabelMessages.max;
    }
    if (isPro) {
        return planLabelMessages.pro;
    }
    return planLabelMessages.free;
}
//# sourceMappingURL=SidebarAccountMenu.js.map